import { render } from "./TemplateNew.vue?vue&type=template&id=2251603f"
import script from "./TemplateNew.vue?vue&type=script&lang=js"
export * from "./TemplateNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__